import {
	takeLatest,
	call,
	put,
	all,
	takeEvery,
	select,
} from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/_sgu';
import { CHANNEL } from 'services/_path';
import {
	getApi as getApiRotaSP,
	ApiResponse as ApiResponseRotaSP,
} from 'services/rotasp/api';

// TYPES
import { PATH_SGU_API, PATH_CEP_API } from 'services/rotasp/path';
import { ReducerAction } from '../types';
import { Types } from './types';

// ACTIONS
import {
	pesquisaNaturalidadeSuccess,
	pesquisaNaturalidadeFailure,
	// listaCepSuccess,
	// listaCepFailure,
	consultaMainframeSuccess,
	consultaMainframeFailure,
} from './actions';

interface IRequestPesquisaNaturalidade {
	canal: string;
	registroInicial?: number;
	limite?: number;
	id?: number;
	descricao?: string;
	idIbge?: number;
	ufIbge: string;
}

interface IRequestListaCep {
	uf: string;
	cidade: string;
	logradouro: string;
	numero?: string | number;
}

interface IRequestConsultaMainframe {
	cpf: string;
	codigoLocalidade: string;
}

function* pesquisaNaturalidadeRequest(request: ReducerAction) {
	const { payload }: { payload: IRequestPesquisaNaturalidade } = request;

	const response: ApiResponse = yield call(
		getApi,
		`domain-service/${CHANNEL}/naturalidade`,
		payload,
	);

	if (
		response.status === 200 ||
		response.status === 201 ||
		response.status === 204
	) {
		yield put(pesquisaNaturalidadeSuccess(response.data));
	} else if (response.error) {
		yield put(pesquisaNaturalidadeFailure(response.message));
	}
}

function* listaCep(request: ReducerAction) {
	const { token, payload }: { token?: string; payload: any } = request;

	const instance = payload.instanceRequest;

	delete payload.instanceRequest;

	const defaulErrorMessageCorporativeCEP =
		'O CEP informado não foi encontrado. Por gentileza, revise a informação ou verifique se o CEP existe junto a base dos correios.';

	const response: ApiResponse = yield call(
		getApiRotaSP,
		token || '',
		PATH_CEP_API,
		`v3/enderecos`,
		payload,
		defaulErrorMessageCorporativeCEP,
	);

	if (response.status === 200) {
		yield put(
			pesquisaNaturalidadeSuccess({
				response: response.data,
				instanceRequest: instance,
			}),
		);
	} else {
		yield put(
			pesquisaNaturalidadeFailure({
				response,
				instanceRequest: instance,
			}),
		);
	}
}

function* consultaMainframe(request: ReducerAction) {
	const { payload }: { payload: IRequestConsultaMainframe } = request;
	const { cpf, codigoLocalidade } = payload;

	const token: string = yield select(state => state.user.token.data);

	const response: ApiResponseRotaSP = yield call(
		getApiRotaSP,
		token,
		PATH_SGU_API,
		`usuarios-mainframe`,
		{
			cpf,
			idLocalidadeUsuario: codigoLocalidade,
		},
	);

	if (response.status === 200) {
		yield put(consultaMainframeSuccess({ response, request: payload }));
	} else if (response.error) {
		yield put(consultaMainframeFailure(response.message));
	}
}

export default all([
	takeLatest(Types.PESQUISA_NATURALIDADE_REQUEST, pesquisaNaturalidadeRequest),
	takeLatest(Types.LISTA_CEP, listaCep),
	takeEvery(Types.CONSULTA_MAINFRAME, consultaMainframe),
]);
